import { render, staticRenderFns } from "./DemonstrativoConceito.vue?vue&type=template&id=1b21c433&"
import script from "./DemonstrativoConceito.vue?vue&type=script&lang=js&"
export * from "./DemonstrativoConceito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports